import React, { Fragment } from 'react';
import './translations.scss';

const Translations = props => <Fragment>{props.children}</Fragment>;

export default  Translations;
